import { useState, useCallback, useEffect } from "react";
import { createGalleryRequest, getGalleryRequest } from "../network";

export const useGetGallery = (id) => {
  const [galleryData, setGalleryData] = useState<any>({});

  const getGallery = useCallback(async () => {
    const res = await getGalleryRequest(id);
    setGalleryData(res.data);
    return res.data;
  }, [id]);

  useEffect(() => {
    getGallery();
  }, [getGallery]);

  return { galleryData, getGallery };
};
